import { render, staticRenderFns } from "./bikers.vue?vue&type=template&id=2480c538&scoped=true&"
import script from "./bikers.vue?vue&type=script&lang=js&"
export * from "./bikers.vue?vue&type=script&lang=js&"
import style0 from "./bikers.vue?vue&type=style&index=0&id=2480c538&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2480c538",
  null
  
)

export default component.exports